<script setup lang="ts">
import { computed } from "vue";

import { cardKey } from "@/components/StickyNote/injectKeys";
import AttributeChip from "@/components/chip/AttributeChip.vue";
import { useArtStore } from "@/store/art";
import { injectStrict } from "@/utils/vue";

import ArtSelectDropdown from "./ArtSelectDropdown.vue";

const card = injectStrict(cardKey);

const arts = computed(() => useArtStore().arts);
const selected = computed(() => useArtStore().artById(card.artId));
</script>

<template>
  <AttributeChip
    name="art-select-chip"
    :text="selected?.name"
    :text-placeholder="$t('actions.art')"
    :tooltip="$t('actions.art')"
    :dropdown-props="{ width: 'md' }"
  >
    <ArtSelectDropdown :selected :arts />
  </AttributeChip>
</template>
